import { Briefcase, Cpu, Dumbbell, GraduationCap, Palette, Pen } from "lucide-react";

import { Textarea } from "@/components/ui";

const ARCHETYPES = [
  {
    id: "professional",
    label: "The Professional",
    icon: Briefcase,
    desc: "Business & Tech",
  },
  {
    id: "creative",
    label: "The Creative",
    icon: Palette,
    desc: "Art & Lifestyle",
  },
  {
    id: "mentor",
    label: "The Mentor",
    icon: Dumbbell,
    desc: "Motivation & Health",
  },
  {
    id: "scholar",
    label: "The Scholar",
    icon: GraduationCap,
    desc: "Academic & Research",
  },
  {
    id: "cyber",
    label: "The Cyber",
    icon: Cpu,
    desc: "Digital & Gaming",
  },
  {
    id: "custom",
    label: "Custom",
    icon: Pen,
    desc: "Your own style",
  },
];

interface ArchetypeSelectorProps {
  value: string;
  onChange: (id: string) => void;
  customStyle: string;
  onCustomStyleChange: (v: string) => void;
}

export function ArchetypeSelector({
  value,
  onChange,
  customStyle,
  onCustomStyleChange,
}: ArchetypeSelectorProps) {
  return (
    <div className="space-y-2">
      <label className="block font-medium text-sm text-zinc-700">Appearance</label>
      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 sm:gap-3">
        {ARCHETYPES.map((a) => {
          const Icon = a.icon;
          const selected = value === a.id;
          return (
            <button
              key={a.id}
              type="button"
              onClick={() => onChange(a.id)}
              className={`flex flex-col items-center gap-1.5 rounded-2xl border-2 p-3 transition-all active:scale-[0.97] sm:gap-2 sm:p-4 ${
                selected
                  ? "border-primary bg-background shadow-md shadow-primary/10"
                  : "border-zinc-200 bg-white hover:border-primary/70 hover:bg-background/70"
              }`}
            >
              <div
                className={`flex h-10 w-10 items-center justify-center rounded-xl ${
                  selected ? "bg-primary text-white" : "bg-zinc-100 text-zinc-500"
                }`}
              >
                <Icon className="h-5 w-5" />
              </div>
              <span
                className={`font-semibold text-sm ${
                  selected ? "text-primary" : "text-zinc-700"
                }`}
              >
                {a.label}
              </span>
              <span className="text-xs text-zinc-400">{a.desc}</span>
            </button>
          );
        })}
      </div>
      {value === "custom" && (
        <Textarea
          value={customStyle}
          onChange={(e) => onCustomStyleChange(e.target.value)}
          placeholder="Describe your style... e.g. 'Calm yoga instructor in white linen, speaking softly with gentle hand gestures'"
        />
      )}
    </div>
  );
}
